module.exports = __webpack_public_path__ + "0.1.2/img/zhankai.0abaffc4.png";